.main {
	max-width: 1920px;
	padding: 20px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	gap: 20px;
	background-color: white;
}

.section {
	max-width: 1200px;
	width: 100%;
	padding: 0;
	margin: 0 auto;
}

.heads {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.heads h1 {
	font-size: var(--text-xl);
	font-weight: 700;
	margin: 0 0 var(--text-xl);
	color: var(--secondary-color-gray800);
}

.heads button {
	display: inline-block;
	width: auto;
	height: auto;
	border-radius: 8px;
	padding: 12px 23px;
	font-size: var(--text-lg);
	font-weight: 600;
	cursor: pointer;
	background-color: var(--primary-color-100);
}

.heads button:disabled {
	background-color: var(--secondary-color-gray400);
}

.form {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 20px;
}

.form label {
	font-size: var(--text-2xl);
	font-weight: 700;
	color: var(--secondary-color-gray800);
	width: 100%;
	margin-bottom: var(--text-xl);
}

.form input {
	font-size: var(--text-lg);
	font-weight: 400;
	line-height: 24px;
	padding: 16px 24px;
	width: 100%;
}

.form textarea {
	font-size: var(--text-lg);
	min-height: 10em;
	height: 15em;
	max-height: 20em;
	resize: vertical;
	overflow-y: auto;
	font-weight: 400;
	line-height: 24px;
	padding: 16px 24px;
	width: 100%;
}

.form .error {
	margin-bottom: var(--text-3xl);
	color: var(--error-color);
	font-size: var(--text-md);
}

.trigger {
	border: 2px solid rgb(208, 255, 0);
	font-weight: 700;
}

.images_list {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
	padding: 0;
	margin: 0;

	& .img_container {
		position: relative;
		display: inline-block;
		width: 120px;
		height: 120px;

		& img {
			position: absolute;
			inset: 0;
		}

		& .delete {
			position: absolute;
			right: 5px;
			top: 5px;
			display: inline-block;
			cursor:pointer;
			width: 20px;
			height: 20px;
			border-radius: 9999px;
			background-color: var(--secondary-color-gray400);
		}
	}
}

.tags_list {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
	padding: 0;
	margin: 0;

	& .tag {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
		border-radius: 26px;
		padding: 6px 12px;
		background-color: var(--secondary-color-gray100);

		& .tag_name {
			font-size: var(--text-lg);
			font-weight: 400;
		}

		& .delete {
			position: relative;
			display: inline-block;
			cursor:pointer;
			width: 20px;
			height: 20px;
			border-radius: 9999px;
			background-color: var(--secondary-color-gray400);
		}
	}
}

.delete>svg {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;

	&>g {
		stroke: white;
		stroke-width: 10%;
		stroke-linecap: square;
	}
}

.none {
	display: none;
}

@media (max-width:1200px) {

	.main {
		padding: 15px;
	}
}

@media (max-width:744px) {

	.main {
		padding: 10px;
	}
}
